import api from "../../../../../api/axios";

// Manager-facing Lease Addendum API. Uses the shared authed axios instance.
// Backend lives in the ./src lease module, mounted at /v2/lease/addendum.
const BASE = "v2/lease/addendum";

export const listAddendums = (mastersheetItemId) =>
  api.get(BASE, { params: { mastersheet_item_id: mastersheetItemId } });

// Tenant contacts + lease dates from the unit's newest non-archived lease.
export const getAddendumPrefill = ({ property_id, unit_no, building_name }) =>
  api.get(`${BASE}/prefill`, { params: { property_id, unit_no, building_name } });

export const createAddendum = (payload) => api.post(BASE, payload);

export const updateAddendum = (id, payload) => api.patch(`${BASE}/${id}`, payload);

export const sendAddendum = (id, body = {}) =>
  api.post(`${BASE}/${id}/send`, body);

export const completeAddendum = (id, landlord_signature) =>
  api.post(`${BASE}/${id}/complete`, { landlord_signature });

export const voidAddendum = (id, reason) => api.post(`${BASE}/${id}/void`, { reason });

export const getAddendumSignedUrl = (id) => api.get(`${BASE}/${id}/signed-url`);
